import moment from "moment"
import React from "react"
import { Date, DateContainer, Day } from "../styles/dateCard.style"

export default function DateCard({ endDate, isMultiday, date, status }) {
  return endDate ? (
    <DateContainer status={status}>
      <Day>
        {isMultiday
          ? moment(date, "MM-DD-YYYY")
              .format("MMM")
              .toUpperCase()
          : moment(date, "MM-DD-YYYY")
              .format("ddd")
              .toUpperCase()}
      </Day>
      <Date>
        {isMultiday
          ? `${moment(date, "MM-DD-YYYY").format("D")} - ${moment(
              endDate,
              "MM-DD-YYYY"
            ).format("D")}`
          : moment(date, "MM-DD-YYYY")
              .format("MMM DD")
              .toUpperCase()}
      </Date>
    </DateContainer>
  ) : (
    <DateContainer status={status}>
      <Day>
        {moment(date, "MM-DD-YYYY")
          .format("ddd")
          .toUpperCase()}
      </Day>
      <Date>
        {moment(date, "MM-DD-YYYY")
          .format("MMM D")
          .toUpperCase()}
      </Date>
    </DateContainer>
  )
}
